export default "/images/vendor/flag-icon-css/flags/1x1/mn.svg?e3e8c5f4f4ab09759fd8220e9bd8c586";